<template>
  <BaseForm
    class="property-register-form"
    v-bind="formSettings"
    gtm-submit-event="form_submit_property-register"
    :dark="dark"
  >
    <template #fields>
      <NameField :dark="dark" />
      <TelField :dark="dark" />
      <EmailField :dark="dark" />
      <TypeSelect :dark="dark" />
      <BusinessSelect :dark="dark" :rules="rules" />
      <PolicyPrivacyField :dark="dark" />
    </template>
  </BaseForm>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import NameField from "./fields/NameField.vue";
import EmailField from "./fields/EmailField.vue";
import TelField from "./fields/TelField.vue";
import TypeSelect from "./fields/TypeSelect.vue";
import BusinessSelect from "./fields/BusinessSelect.vue";
import PolicyPrivacyField from "./fields/PolicyPrivacyField.vue";
import { requiredValidation } from "./validations/requiredValidation";

const _data = {
  rules: [requiredValidation("Selecione a finalidade.")],
  formSettings: {
    action: "/rest/email/property-register",
    responseTo: "/cadastre-seu-imovel/obrigado",
  },
};

export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ..._data,
  }),
  components: {
    BaseForm,
    NameField,
    EmailField,
    TelField,
    TypeSelect,
    BusinessSelect,
    PolicyPrivacyField,
  },
};
</script>

<style lang="scss">
.property-register-form {
  .base-form-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;

    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    @media screen and (min-width: 600.001px) {
      & > :nth-child(3),
      & > :nth-child(4),
      & > :nth-child(5),
      & > :nth-child(6) {
        grid-column-end: span 2;
      }
    }
  }
}
</style>
